import Moe from '@moengage/web-sdk';

interface InitMoengageArgs {
  debug?: boolean;
  workspaceId?: string | null;
}

export function initMoengage({ debug, workspaceId }: InitMoengageArgs) {
  if (!workspaceId) return;

  Moe.initialize({
    app_id: workspaceId,
    debug_logs: debug ? 1 : 0,
    cluster: 'DC_4',
  });
}
